export class AuctionStatusHistoryDTO{
    public id!:number;
    public auctionId!:number;
    public scheduleSeqNo?:number;
    public status!:string;
    public enteredAt!:string;
    public userName!:string;
    public reason!:string;
}